/** Pads a date component for stable, sortable board names. */
function pad(value: number): string {
  return value.toString().padStart(2, "0");
}

/** Formats a concise, Windows-portable local timestamp for a new board directory. */
export function formatTimestampBoardName(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}.${pad(date.getMinutes())}`;
}

/** Adds the smallest available numeric suffix without changing the base name. */
export function resolveBoardNameCollision(
  baseName: string,
  takenNames: ReadonlySet<string>,
): string {
  if (!takenNames.has(baseName)) {
    return baseName;
  }

  for (let suffix = 2; suffix < Number.MAX_SAFE_INTEGER; suffix += 1) {
    const candidate = `${baseName} ${suffix}`;
    if (!takenNames.has(candidate)) {
      return candidate;
    }
  }

  throw new Error("Shotboard could not resolve the board-name collision.");
}
